export enum EnvironmentVariables {
  VITE_BASE_URL = 'VITE_BASE_URL',
  VITE_FINGER_PRINT = 'VITE_FINGER_PRINT',
  VITE_GRECAPTCHA = 'VITE_GRECAPTCHA',
  VITE_APP_DEEPLINK = 'VITE_APP_DEEPLINK',
  VITE_APP_MIXPANEL = 'VITE_APP_MIXPANEL',
  VITE_APP_LOGROCKET = 'VITE_APP_LOGROCKET',
  VITE_APP_SOCURE = 'VITE_APP_SOCURE',
  VITE_MOCKING = 'VITE_MOCKING',
  VITE_APP_BUG_SNAG = 'VITE_APP_BUG_SNAG',
  VITE_GTM_ID = 'VITE_GTM_ID',
  VITE_SHOULD_AVOID_ROUTE_AUTH_CHECK = 'VITE_SHOULD_AVOID_ROUTE_AUTH_CHECK',
  VITE_SHOULD_JUMP_TO_CUSTOM_PAGE = 'VITE_SHOULD_JUMP_TO_CUSTOM_PAGE',
}

export const getEnvironmentVariable = (key: EnvironmentVariables) => {
  const value = import.meta.env[key];
  if (value === undefined) {
    return 'false';
  }
  return import.meta.env[key];
};

export const isProdEnv = (): boolean => import.meta.env.PROD;

export enum EnvironmentType {
  PROD = 'production',
  DEV = 'development',
}
